var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.045 3.0475C42.7972 0.828 41.4431 0.41975 38.686 0.2645C35.9318 0.077625 29.0059 0 23.0057 0C16.9941 0 10.0654 0.0776252 7.314 0.261625C4.56262 0.41975 3.20563 0.825125 1.94638 3.0475C0.66125 5.26412 0 9.08213 0 15.8039C0 15.8096 0 15.8125 0 15.8125C0 15.8182 0 15.8211 0 15.8211V15.8269C0 22.5199 0.66125 26.3666 1.94638 28.5602C3.20563 30.7798 4.55975 31.1823 7.31112 31.3691C10.0654 31.5301 16.9941 31.625 23.0057 31.625C29.0059 31.625 35.9318 31.5301 38.6889 31.372C41.446 31.1851 42.8001 30.7826 44.0479 28.5631C45.3445 26.3695 46 22.5227 46 15.8297C46 15.8297 46 15.8211 46 15.8154C46 15.8154 46 15.8096 46 15.8068C46 9.08213 45.3445 5.26412 44.045 3.0475ZM17.25 24.4375V7.1875L31.625 15.8125L17.25 24.4375Z","fill":"white"}));
}

Youtube.defaultProps = {"width":"46","height":"32","viewBox":"0 0 46 32","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
